module.exports = __webpack_public_path__ + "img/gris_tweed.b3ab03fb.jpeg";